export const FETCH_USER_URL = `${process.env.REACT_APP_API_URL}/users`;
export const CREATE_USER_URL = `${process.env.REACT_APP_API_URL}/users/create`;
export const UPDATE_USER_URL = `${process.env.REACT_APP_API_URL}/users`;
export const DELETE_USER_URL = `${process.env.REACT_APP_API_URL}/users`;
